function registerModal() {
  // TODO: Remove references to this function
}

export default registerModal
